import { FC } from "react";

import { OFClubPurchaseContainer } from "@features/ofcPurchase/containers/OFClubPurchaseContainer";

export const OFClubPurchasePage: FC = () => {
  return <OFClubPurchaseContainer />;
};
